import {
    ActionWithPayload, createAction, withMatcher,
} from '../../utils/reducer/reducer.utils';
import { LOADING_ACTION_TYPES } from './loading.types';

export type SetIsLoading = ActionWithPayload<
    LOADING_ACTION_TYPES.SET_IS_LOADING,
    { isLoading: boolean; }
>;

export type SetProgress = ActionWithPayload<
    LOADING_ACTION_TYPES.SET_PROGRESS,
    { progress: number | undefined; }
>;

export const setIsLoading = withMatcher(
    (isLoading: boolean): SetIsLoading =>
        createAction(LOADING_ACTION_TYPES.SET_IS_LOADING, { isLoading })
);

export const setProgress = withMatcher(
    (progress: number | undefined): SetProgress =>
        createAction(LOADING_ACTION_TYPES.SET_PROGRESS, { progress })
);